import React from "react";
import { TemplateUserProfile } from "./templateUserProfile";
import { ModalComponent, SpinnerComponent } from "../";
import { getUserProfileInfoAction } from "../../../actions/viewProfile.actions";

export class RedirectUser extends React.Component {
  state = {};

  onGetUserDetail = e => {
    e.preventDefault();
    const { id } = this.props;
    this.setState(
      {
        isProfileLoading: true,
        toggleModal: true
      },
      async () => {
        const response = await getUserProfileInfoAction(undefined, {
          userId: id
        });
        const { data, status, message } = response || {};
        this.setState({
          message,
          userProfile: data,
          isProfileLoading: false
        });
      }
    );
  };

  onToggleModal = () => {
    this.setState(prevState => ({
      toggleModal: !prevState.toggleModal
    }));
  };

  render() {
    const { onGetUserDetail, onToggleModal } = this;
    const {
      title = "",
      isIssueForwarded,
      isProjectProponentDetail,
      isMilestonePPDetail,
      projectnotecss,
      escalationlevelcss
    } = this.props;
    const { message, userProfile, isProfileLoading, toggleModal } = this.state;
    return (
      <>
        {toggleModal ? (
          <ModalComponent
            containerClass="user-profile"
            centered={true}
            template={
              isProfileLoading ? (
                <SpinnerComponent containerClasses="spinners" />
              ) : (
                <TemplateUserProfile
                  info={userProfile}
                  onClose={onToggleModal}
                />
              )
            }
            onClose={onToggleModal}
          />
        ) : null}
        {isProjectProponentDetail === true ? (
          <div
            className="issue-creator-name text-left"
            onClick={onGetUserDetail}
          >
            {title}
          </div>
        ) : (
          <span
            className={`issue-creator-name ${
              isMilestonePPDetail ? "user-detail-in-milestone" : ""
            } ${isIssueForwarded ? "" : "text-left"}`}
            onClick={onGetUserDetail}
            style={{
              fontSize: projectnotecss || escalationlevelcss ? 13 : null,
              fontFamily: projectnotecss ? "mpr" : null
            }}
          >
            {title}
          </span>
        )}
      </>
    );
  }
}
